module.exports = __webpack_public_path__ + "static/media/red_canary.9755eca9.png";